/**
 * acc.ts — Categoría "Accesorios" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_acc",
  skuPrefix: "ACC",
  categoria: "Accesorios",
} as const;

export const cat_acc_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Bolso Dama Cuero",
    marca: "Vélez",
    modelo: "Tote Medium",
    origen: "Colombia",
    costo: 185000,
    precio: 289000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC1",
    proveedor: "Vélez",
    material: "Cuero vacuno",
    colorProducto: "Negro",
    dimensiones: "35x30x12cm",
    descripcionLarga:
      "Bolso tote mediano de cuero genuino con asas reforzadas y bolsillo interior con cierre. Versátil para trabajo y paseo.",
    especificaciones: [
      { clave: "Material", valor: "Cuero vacuno" },
      { clave: "Tamaño", valor: "Mediano" },
    ],
    imageKeywords: ["leather-handbag", "womens-bag", "tote-bag"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Billetera Hombre Cuero",
    marca: "Vélez",
    modelo: "Bi-Fold Slim",
    origen: "Colombia",
    costo: 65000,
    precio: 99900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC1",
    proveedor: "Vélez",
    material: "Cuero vacuno",
    colorProducto: "Café",
    dimensiones: "11x9cm",
    descripcionLarga:
      "Billetera bi-fold de cuero genuino con 6 ranuras para tarjetas, compartimento billetes y ventana identificación.",
    especificaciones: [
      { clave: "Ranuras tarjeta", valor: "6" },
      { clave: "Material", valor: "Cuero" },
    ],
    imageKeywords: ["leather-wallet", "mens-wallet", "bifold"],
    color: "bg-amber-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Cinturón Hombre Cuero",
    marca: "Arturo Calle",
    modelo: "Reversible",
    origen: "Colombia",
    costo: 58500,
    precio: 89900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC1",
    proveedor: "Arturo Calle S.A.S.",
    material: "Cuero",
    colorProducto: "Negro/café",
    dimensiones: "3.5cm x 120cm",
    descripcionLarga:
      "Cinturón ejecutivo reversible negro/café con hebilla giratoria plateada. Una compra, dos estilos.",
    especificaciones: [
      { clave: "Ancho", valor: "3.5cm" },
      { clave: "Estilo", valor: "Reversible" },
    ],
    imageKeywords: ["leather-belt", "mens-belt", "dress-belt"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Gafas de Sol Unisex",
    marca: "Ray-Ban",
    modelo: "Wayfarer Classic",
    origen: "Italia",
    costo: 285000,
    precio: 449000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC2",
    proveedor: "Luxottica Group",
    garantia: "2 años",
    material: "Acetato y cristal",
    colorProducto: "Negro",
    descripcionLarga:
      "Gafas Ray-Ban Wayfarer originales con lentes de cristal protección UV400. El icono de la moda desde 1952.",
    especificaciones: [
      { clave: "Lente", valor: "Cristal UV400" },
      { clave: "Marco", valor: "Acetato" },
    ],
    imageKeywords: ["sunglasses", "wayfarer", "rayban"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Gorra Ajustable Unisex",
    marca: "New Era",
    modelo: "9Forty",
    origen: "Bangladesh",
    costo: 65000,
    precio: 99900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Estante AC3",
    proveedor: "New Era Colombia",
    material: "Algodón twill",
    colorProducto: "Negro",
    descripcionLarga:
      "Gorra New Era 9Forty con cierre trasero ajustable velcro. Visera curva, logo bordado frontal.",
    especificaciones: [
      { clave: "Cierre", valor: "Velcro" },
      { clave: "Visera", valor: "Curva" },
    ],
    imageKeywords: ["baseball-cap", "new-era", "hat"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Bufanda Lana Mujer",
    marca: "Zara",
    origen: "España",
    costo: 32500,
    precio: 49900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante AC3",
    proveedor: "Zara Colombia",
    material: "80% lana, 20% acrílico",
    colorProducto: "Beige",
    dimensiones: "180x45cm",
    descripcionLarga:
      "Bufanda tejida mezcla lana, extra larga y suave. Ideal para clima frío o looks otoñales.",
    especificaciones: [
      { clave: "Material", valor: "Lana mezcla" },
      { clave: "Dimensiones", valor: "180x45cm" },
    ],
    imageKeywords: ["wool-scarf", "winter-scarf", "knit-scarf"],
    color: "bg-amber-200",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Reloj Deportivo Hombre",
    marca: "Casio",
    modelo: "G-Shock GA-100",
    origen: "Japón",
    costo: 325000,
    precio: 499000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC4",
    proveedor: "Casio Colombia",
    garantia: "2 años",
    material: "Resina y acero",
    colorProducto: "Negro",
    descripcionLarga:
      "Reloj G-Shock resistente a impactos y agua 200m. Pantalla analógica-digital, luz LED, cronógrafo múltiple.",
    especificaciones: [
      { clave: "Resistencia", valor: "200m" },
      { clave: "Tipo", valor: "Analógico-digital" },
    ],
    imageKeywords: ["gshock", "sport-watch", "mens-watch"],
    color: "bg-slate-900",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Mochila Urbana 25L",
    marca: "Jansport",
    modelo: "SuperBreak",
    origen: "Vietnam",
    costo: 85000,
    precio: 129000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante AC5",
    proveedor: "Jansport Colombia",
    garantia: "Vitalicia",
    material: "Poliéster 600D",
    colorProducto: "Gris",
    dimensiones: "42x33x21cm",
    descripcionLarga:
      "Mochila SuperBreak clásica 25L con un compartimento principal y bolsillo frontal. Tirantes acolchados.",
    especificaciones: [
      { clave: "Capacidad", valor: "25L" },
      { clave: "Laptop", valor: 'Hasta 15"' },
    ],
    imageKeywords: ["backpack", "jansport", "school-backpack"],
    color: "bg-slate-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Paraguas Automático Plegable",
    marca: "Totto",
    origen: "Colombia",
    costo: 32500,
    precio: 49900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Estante AC5",
    proveedor: "Totto Colombia",
    material: "Poliéster y fibra vidrio",
    colorProducto: "Azul marino",
    descripcionLarga:
      "Paraguas plegable 3 secciones con apertura y cierre automáticos. Varillas fibra de vidrio anti-viento.",
    especificaciones: [
      { clave: "Apertura", valor: "Automática" },
      { clave: "Diámetro", valor: "98cm" },
    ],
    imageKeywords: ["umbrella", "folding-umbrella", "rain-umbrella"],
    color: "bg-blue-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Corbata Seda Hombre",
    marca: "Hugo Boss",
    origen: "Italia",
    costo: 95000,
    precio: 149000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AC6",
    proveedor: "Hugo Boss Colombia",
    material: "100% seda",
    colorProducto: "Azul rey",
    dimensiones: "150x8cm",
    descripcionLarga:
      "Corbata ejecutiva 100% seda italiana, tejido jacquard con patrón micro. Incluye estuche de regalo.",
    especificaciones: [
      { clave: "Material", valor: "Seda" },
      { clave: "Ancho", valor: "8cm" },
    ],
    imageKeywords: ["silk-tie", "mens-tie", "necktie"],
    color: "bg-blue-800",
    shape: "square",
  }),
];
